import { ConnectionNames } from "../../../contracts";
import { ConfigStore, storeToken } from "../../../common";
export class BaseSportsSubscriber {
    constructor(onDataCallback, onErrorCallback) {
        this.name = "subscribe";
        this.query = undefined;
        this.onDataCallback = onDataCallback;
        this.onErrorCallback = onErrorCallback;
    }
    onData(x) {
        if (x) {
            this.onDataCallback(x);
        }
    }
    getLocale() {
        var _a;
        return ((_a = ConfigStore.config.urls.SportsbookConnection) === null || _a === void 0 ? void 0 : _a.queryParams.locale) || "en-US";
    }
    getName() {
        return this.name;
    }
    onError(e) {
        this.onErrorCallback(e);
        ConfigStore.config.requestToken().then(token => {
            storeToken(token);
            this.reInitQuery();
        }).catch((error) => {
            ConfigStore.config.tracking[ConnectionNames.sports].trackError({
                message: `Token request failed: ${JSON.stringify(error)}`,
                clientAction: "TOKEN_REQUEST_ERROR",
            });
        });
    }
    deactivate() {
        this.query = undefined;
    }
    reInitQuery() {
        const currentQuery = this.query;
        this.query = undefined;
        this.query = currentQuery ? Object.assign(Object.assign({}, currentQuery), { params: Object.assign({}, currentQuery.params) }) : undefined;
        ConfigStore.config.tracking[ConnectionNames.sports].trackData({
            message: `Reinit query: ${JSON.stringify(this.query)} with token: ${ConfigStore.config.connections.jwt}`,
            clientAction: "RE_INIT_QUERY",
        });
    }
}
//# sourceMappingURL=BaseSportsSubscriber.js.map